import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IProduct } from 'src/app/models/products/product';

@Component({
    selector: 'app-step-pre-production',
    templateUrl: './step-pre-production.component.html',
    styleUrls: ['./step-pre-production.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class StepPreProductionComponent implements OnInit {
  @Input() product!: IProduct;

  content: any[] = [];

  ngOnInit(): void {
    this.buildContent();
  }

  private buildContent(): void {
    const settingConfig = [
      { label: 'Package', value: 'packageName', type: 'text', col: '3' },
      { label: 'Setting', value: 'settingName', type: 'text', col: '3' },
      { label: 'Width', value: 'width', type: 'number', col: '2' },
      { label: 'Depth', value: 'depth', type: 'number', col: '2' },
      { label: 'Height', value: 'height', type: 'number', col: '2' },
      { label: 'Lens', value: 'lens', type: 'text', col: '2' },
      { label: 'Weight', value: 'weight', type: 'text', col: '2' },
      { label: 'Ingestion Date', value: 'createdAt', type: 'date', col: '2' },
    ];
    const settingData = this.product.productTouches.sort(
      (a, b) => a.masterSuiteTouchIndex - b.masterSuiteTouchIndex,
    );
    const settingVisible = this.product.productTouches && this.product.productTouches.length > 0;

    this.content = [
      {
        id: 'receivals',
        icon: 'receipt_long',
        label: 'Receivals',
        state: this.product.receivedCount > 0 ? 'Received' : 'Pending',
        showAdditional: this.product.productReceivals.length > 0,
        additional: this.product.productReceivals,
        additionalConfig: [
          { label: 'Container Code', value: 'containerId', type: 'text', col: '2' },
          { label: 'Condition', value: 'condition', type: 'text', col: '2' },
          { label: 'Date', value: 'createdAt', type: 'date', col: '2' },
        ],
      },
      {
        id: 'setting',
        icon: 'lightbulb',
        label: 'Settings',
        additional: [this.product],
        showAdditional: this.product.masterSuiteId !== null,
        additionalConfig: [
          { label: 'Master Suite', value: 'masterSuiteName', type: 'text', col: '2' },
          { label: 'Settings Variant', value: 'settingsVariantName', type: 'text', col: '2' },
          { label: 'Date', value: 'settingsDate', type: 'date', col: '2' },
        ],
        state:
          this.product.masterSuiteId != null && this.product.settingsVariantId != null
            ? 'Applied'
            : this.product.settingsVariantId == null && this.product.masterSuiteId != null
              ? 'Pending Settings'
              : 'Pending',
      },
      {
        id: 'ingestion',
        icon: 'dataset',
        label: 'Ingestion',
        showAdditional: settingVisible,
        additional: settingData,
        additionalConfig: settingConfig,
        state:
          this.product.ingestedTouchCount === this.product.expectedTouchCount &&
          this.product.expectedTouchCount !== 0
            ? 'Ingested'
            : this.product.ingestedTouchCount > 0
              ? 'Partial'
              : 'Pending',
      },
    ];
  }
}
